(() => {
  const init = (root = document) => {
    root.querySelectorAll('[data-japotyle-mobile-filter]').forEach((shell) => {
      if (shell.dataset.mobileFilterReady === 'true') return;
      const toggle = shell.querySelector('[data-japotyle-mobile-filter-toggle]');
      const panel = shell.querySelector('.japotyle-filter-panel');
      if (!toggle || !panel) return;

      shell.dataset.mobileFilterReady = 'true';
      toggle.addEventListener('click', () => {
        const isOpen = shell.classList.toggle('is-open');
        toggle.setAttribute('aria-expanded', String(isOpen));
      });
    });
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => init());
  } else {
    init();
  }

  document.addEventListener('shopify:section:load', (event) => init(event.target));
})();
